export const ROLE_OPTIONS = [
  "admin",
  "trader",
  "viewer",
  "account_manager",
  "sales",
  "risk",
] as const;

export type Role = (typeof ROLE_OPTIONS)[number];

export const ROLE_IMPLICATIONS: Record<Role, Role[]> = {
  admin: ["trader", "viewer", "account_manager", "sales", "risk"],
  trader: ["viewer"],
  viewer: [],
  account_manager: ["viewer"],
  sales: ["viewer"],
  risk: ["viewer"],
};

export function isRole(value: string): value is Role {
  return (ROLE_OPTIONS as readonly string[]).includes(value);
}
